export default __webpack_public_path__ + "static/media/Arimo-Regular.380e2b36.ttf";